import {CreativeBean} from 'common/api/api.ts';
import {env} from 'common/env';
import React, {useEffect, useRef, useState} from 'react';
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import 'videojs-ima'
import PreviewNative from './PreviewNative.tsx';

interface PreviewPanelProps {
    id?: string;
    format: CreativeBean.FormatEnum;
    width?: number;
    height?: number;
    adCode?: string;
    forceIframeForNative?: boolean;
}


export const PreviewPanel: React.FC<PreviewPanelProps> = ({
                                                              id,
                                                              format,
                                                              width,
                                                              height,
                                                              adCode,
                                                              forceIframeForNative
                                                          }) => {
    const containerRef = useRef<HTMLVideoElement | null>(null);
    const [error, setError] = useState<string>();

    useEffect(() => {
        if (!id) return;
        if (format === CreativeBean.FormatEnum.Video && adCode) {
            const player = videojs('my-video', {
                controls: true,
                autoplay: false,
                preload: 'auto'
            })
            player['ima']({
                adTagUrl: 'env.creativePreview + \'?id=\' + id'
            })
            player.on('error', () => {
                setError(player?.error()?.toString()|| 'unknown error');
            })
        }
    }, [id, format, adCode]);

    if (!id) return null;

    if (format === CreativeBean.FormatEnum.NativeAds && !forceIframeForNative) {
        return <PreviewNative crid={Number(id)}/>;
    }

    if ([CreativeBean.FormatEnum.HTML, CreativeBean.FormatEnum.HTML5, CreativeBean.FormatEnum.ImageLink, CreativeBean.FormatEnum.NativeAds].includes(format)) {
        return (
            <iframe
                width={width}
                height={height}
                frameBorder={0}
                sandbox={format === CreativeBean.FormatEnum.HTML5
                    ? 'allow-scripts allow-popups allow-popups-to-escape-sandbox'
                    : 'allow-popups allow-popups-to-escape-sandbox'}
                src={env.creativePreview + '?id=' + id}
            />
        );
    }

    if (format === CreativeBean.FormatEnum.Video && adCode) {
        return (<>
                {error && <span style={{color: 'red'}}>{error}</span>}
                <video ref={containerRef} className="video-js vjs-big-play-centered"/>
            </>
        );
    }

    return null;
};
